import script from "./employeePopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./employeePopUp.vue?vue&type=script&setup=true&lang=js"

import "./employeePopUp.vue?vue&type=style&index=0&id=8a32a258&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a32a258"]])

export default __exports__